import { render } from "./AddContract.vue?vue&type=template&id=533dc77e"
import script from "./AddContract.vue?vue&type=script&lang=js"
export * from "./AddContract.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__